/**
 * Background site audio.
 *
 * Uses a <video> element so muted autoplay is always allowed by browsers.
 * Starts muted on load, then unmutes once playback is confirmed running.
 */

const LOADER_COMPLETE_EVENT = 'zlc:site-loader-complete';

function setToggleState(toggle, isMuted) {
	toggle.classList.toggle('is-muted', isMuted);
	toggle.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
	toggle.setAttribute(
		'aria-label',
		isMuted ? 'Unmute site audio' : 'Mute site audio'
	);
}

function unmute(el, toggle) {
	el.muted = false;
	el.removeAttribute('muted');
	el.volume = 1;
	setToggleState(toggle, false);
}

function mute(el, toggle) {
	el.muted = true;
	el.volume = 1;
	setToggleState(toggle, true);
}

export function initSiteHeaderAudio() {
	const el = document.getElementById('zlc-site-audio');
	const toggle = document.getElementById('zlc-site-audio-toggle');

	if (!el || !toggle) {
		return;
	}

	let userMuted = false;
	let unmuteScheduled = false;

	el.volume = 1;
	setToggleState(toggle, false);

	el.addEventListener('playing', () => {
		if (!unmuteScheduled) {
			return;
		}
		unmuteScheduled = false;

		if (!userMuted) {
			unmute(el, toggle);
		}
	});

	const scheduleUnmute = () => {
		if (userMuted || (!el.muted && !el.paused)) {
			return;
		}

		unmuteScheduled = true;

		if (el.paused) {
			el.play().catch(() => {});
		} else {
			unmute(el, toggle);
		}
	};

	window.addEventListener(LOADER_COMPLETE_EVENT, scheduleUnmute, { once: true });

	if (!document.getElementById('site-loader')) {
		scheduleUnmute();
	}

	const unlockOnInteraction = () => {
		scheduleUnmute();
	};

	document.addEventListener('pointerdown', unlockOnInteraction, { once: true });
	document.addEventListener('keydown', unlockOnInteraction, { once: true });
	document.addEventListener('scroll', unlockOnInteraction, { once: true });

	toggle.addEventListener('click', () => {
		userMuted = !userMuted;

		if (userMuted) {
			mute(el, toggle);
		} else {
			unmute(el, toggle);
			if (el.paused) {
				el.play().catch(() => {});
			}
		}
	});
}
